<div class="container-fluid">
    <ng-container *ngIf="configLoaded">
        <app-log-select
            [header]="config.header"
            [showLocation]="config['showLocation'] ?? false"
            [showDaterange]="config['showDaterange'] ?? true"
            [DateTimerange]="config['DateTimerange'] ?? false"
            [timeDuration]="config['timeDuration'] ?? 0"
            [showSingleDate]="config['showSingleDate'] ?? false"
            [SingleLocationDropdown]="config['SingleLocationDropdown'] ?? false"
            [ShowLocationDropdown]="config['ShowLocationDropdown'] ?? false"
            [AllSelection]="config['AllSelection'] ?? false"
            [showappliances]="config['showappliances'] ?? false"
            [FromToLocation]="config['FromToLocation'] ?? false"
            [showSites]="config['showSites'] ?? false"
            [SiteOnly]="config['SiteOnly'] ?? false"
            [Nolocation]="config['Nolocation'] ?? false"
            [MultiSites]="config['MultiSites'] ?? false"
            [AllSites]="config['AllSites'] ?? true"
            [showsubtype]="config['showsubtype'] ?? false"
            [showBillNo]="config['showBillNo'] ?? false"
            [Month_Year]="config['Month_Year'] ?? false"
            [Month_Range]="config['Month_Range'] ?? false"
            [Date_Time]="config['Date_Time'] ?? false"
            [Date_time]="config['Date_time'] ?? false"
            [Date_Flat]="config['Date_Flat'] ?? false"
            [Hours]="config['Hours'] ?? false"
            [search]="config['search'] ?? false"
            [dropdown]="config['dropdown'] ?? false"
            [dropdownOptions]="config['dropdownOptions']"
            [placeholder]="config['placeholder']"
            [InputField]="config['InputField'] ?? false"
            [InputFields]="config['InputFields'] ?? []"
            [filterConfig]="config['filterConfig'] ?? []"
            (filtersApplied)="handleFilters($event)"
            (showTable)="handlereset($event)">
        </app-log-select>
    </ng-container>

    <div class="row" *ngIf="!showtable">
        <img src="assets/DashboardIcon/applyfilters.svg" alt="" height="300px" width="400px">
    </div>

    <div class="row" *ngIf="showtable">
        <app-table
            [location]="config['tableLocation'] ?? false"
            [pageNation]="true"
            [paginationPageSizeSelector]="[10,20,50]"
            [maxRowCount]="totalCount"
            (onPageChange)="handlePageChange($event)">
        </app-table>
    </div>
</div>
